import { render, staticRenderFns } from "./notice-info.vue?vue&type=template&id=21a346d1&scoped=true&"
import script from "./notice-info.vue?vue&type=script&lang=js&"
export * from "./notice-info.vue?vue&type=script&lang=js&"
import style0 from "./notice-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./notice-info.vue?vue&type=style&index=1&id=21a346d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a346d1",
  null
  
)

export default component.exports